import { Component, input } from '@angular/core';
import { Product } from '../../../shared/types/product';
import { ProductCardComponent } from '../product-card/product-card.component';

@Component({
    selector: 'app-product-row',
    templateUrl: './product-row.component.html',
    styleUrls: ['./product-row.component.scss'],
    standalone: true,
    imports: [ProductCardComponent]
})
export class ProductRowComponent {
  readonly productRow = input.required<Product[]>();
  readonly cardWidth = input<number | null>(null);
}
